import { assetURL } from 'utils/assets'
import { defaultAxios } from 'utils/io/http/axios'

export const FORM_NAME = 'AndroidPublishSettings'

export const requiredFactory = fieldName => value => {
  if (value) return undefined

  return `${fieldName} is required`
}

// Bundle ID displays as "Package Name"
const JAVA_KEYWORDS = [
  'abstract',
  'assert',
  'boolean',
  'break',
  'byte',
  'case',
  'catch',
  'char',
  'class',
  'const',
  'continue',
  'default',
  'do',
  'double',
  'else',
  'enum',
  'extends',
  'final',
  'finally',
  'float',
  'for',
  'goto',
  'if',
  'implements',
  'import',
  'instanceof',
  'int',
  'interface',
  'long',
  'native',
  'new',
  'package',
  'private',
  'protected',
  'public',
  'return',
  'short',
  'static',
  'strictfp',
  'super',
  'switch',
  'synchronized',
  'this',
  'throw',
  'throws',
  'transient',
  'try',
  'void',
  'volatile',
  'while',
  'true',
  'false',
  'null',
]

export const validateBundleIdFormat = val => {
  if (!val.match(/^[A-Za-z\d_]+\.[A-Za-z\d_]+/g)) {
    return 'Android Package Names must have at least two segments, i.e. at least one period.'
  }

  if (val.match(/[^a-z\d\_\.]/i)) {
    return 'Can only contain letters, numbers, underscores (_) and dots (.)'
  }

  // Check for Java keywords as complete segments
  const segments = val.split('.')
  for (const segment of segments) {
    const segmentLower = segment.toLowerCase()
    if (JAVA_KEYWORDS.includes(segmentLower)) {
      return `Package name cannot contain Java keyword '${segment}' as a complete segment`
    }
  }

  if (val.match(/^([A-Za-z]{1}[A-Za-z\d_]*\.)*[A-Za-z][A-Za-z\d_]*$/)) {
    return undefined
  }

  return 'This Package Name is invalid'
}

export const validateDisplayName = val => {
  if (val.match(/`/i)) {
    return "Cannot contain the '`' backtick character"
  }
}

export const validations = {
  displayName: [requiredFactory('App Display Name'), validateDisplayName],
  bundleId: [requiredFactory('Package Name'), validateBundleIdFormat],
  frontendGoogleServices: [requiredFactory('Frontend google-services.json')],
  notificationsIcon: [requiredFactory('Notifications Icon')],
}

export const asyncValidate = async data => {
  const { frontendGoogleServices, bundleId } = data

  if (!frontendGoogleServices || !bundleId) {
    return
  }

  const googleServices = (
    await defaultAxios.get(assetURL(frontendGoogleServices))
  ).data

  const packageName =
    googleServices?.client?.[0]?.client_info?.android_client_info?.package_name

  if (!packageName) {
    throw { frontendGoogleServices: 'Android app ID is missing' }
  } else if (packageName !== bundleId) {
    throw {
      frontendGoogleServices: `Package Names don’t match. Got ${packageName}`,
    }
  }
}
